


  
  

  var faCheck = {
    prefix: 'fasds',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      ['M448.1 142l-23 22.2L186.7 394.6l-22.2 21.5-22.2-21.5L23 279.4 0 257.2l44.5-46 23 22.2 97 93.7L380.6 118.2l23-22.2 44.5 46z','']
      
    ]
  };

  



export {

  faCheck,
  

};
